import { Controller } from '@hotwired/stimulus'
import { Dropdown } from 'bootstrap'

export default class DropdownButtonController extends Controller {
  static targets = ['toggle', 'menu']

  connect() {
    this.dropdown = new Dropdown(this.element, {
      popperConfig(defaultBsPopperConfig) {
        return {
          ...defaultBsPopperConfig,
          strategy: 'fixed' // Forces the menu to use fixed positioning
        }
      }
    })
    this.element.addEventListener('keydown', this.registerKeydown)
    this.element.addEventListener('show.bs.dropdown', this.onShow)
    this.element.addEventListener('hide.bs.dropdown', this.onHide)

    if (this.dropdown._menu) {
      this.dropdown._links = this.dropdown._menu.querySelectorAll('a, button')
    }
  }

  registerKeydown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      this.keyboardActivated = true
    }
  }

  checkMenuFocus = () => {
    if (!this.dropdown?._menu) return

    const activeElement = document.activeElement
    const isInMenu = this.dropdown._menu.contains(activeElement)
    const isInLinks = Array.from(this.dropdown._links || []).some(
      link => link === activeElement || link.contains(activeElement)
    )

    // If focus is not in the menu or any of the links, hide the dropdown
    if (!isInMenu && !isInLinks) {
      this.dropdown.hide()
    }
  }

  onShow = () => {
    if (this.dropdown._menu) {
      // Update focusable elements
      this.dropdown._links = this.dropdown._menu.querySelectorAll('a, button, [tabindex="0"]')

      if (this.keyboardActivated && this.dropdown._links.length > 0) {
        // Focus first focusable element when opened via keyboard
        setTimeout(() => this.dropdown._links[0].focus())
      }

      // Add event listeners for better keyboard navigation
      this.dropdown._menu.addEventListener('keydown', this.handleMenuKeydown)
    }
    this.updateDropdownAltText(true)
  }

  onHide = () => {
    if (this.dropdown._menu) {
      this.dropdown._menu.removeEventListener('keydown', this.handleMenuKeydown)
    }
    this.keyboardActivated = false
    this.updateDropdownAltText(false)
  }

  handleMenuKeydown = event => {
    if (event.key === 'Tab') {
      setTimeout(() => this.checkMenuFocus(), 0)
    }
  }

  updateDropdownAltText = isOpen => {
    const caretIcon = this.element.querySelector('.button__dropdown')
    const titleElement = caretIcon?.querySelector('title')

    if (titleElement) {
      const newText = isOpen ? 'close dropdown' : 'open dropdown'
      titleElement.textContent = newText
    }
  }
}
